import { useEffect, useState } from "react";
import { Api } from "../../../helpers/Api";
import { useParams } from "react-router-dom";
import { Col, Form } from "react-bootstrap";
import LoadingSpinner from "../Components/Spinner/LoadingSpinner";

const imageContainer = {
    display: 'flex',
    justifyContent: 'left',
    flexWrap: 'wrap',
    gap: '10px',
}

const headStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
}

const yearSelect = {
    width: '90px'
}

const img = {
    width: '150px', /* Adjust size */
    height: '150px',
    objectFit: 'cover', /* Ensures images fit well */
    borderRadius: '8px' /* Optional: Rounded corners */
}



const MediaCollection = ({ user, ...props }) => {

    const [data, setData] = useState(null);
    const [name, setName] = useState(null);
    const [loading, setLoading] = useState(true);
    const [year, setYear] = useState(new Date().getFullYear()); 
    const { department } = useParams();


    const api =  () => {
        setLoading(true);
        Api.call(`/getImageContent/${department}/${year}`).then((res) => {
                setName(res[0]?.Name);
                setData(JSON.parse(res[0]?.report));
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setTimeout(() => {  setLoading(false); }, 1000);
        });
    };

    useEffect(() => {
        if (!department) {
            return;
        }
        api();
    },[year]);

    useEffect(() => {
        if(!department){
            return;
        }
        api();
    },[]);

    const statusChange = (e)=>{
        console.log(e.target.value);
        setYear(e.target.value);
    };

    
    if(loading) {return <LoadingSpinner />} 
    else if(name == null)
    {
    return <div className="right_container">
            <div className="dashboard">
                <div className='inner-content'>
                    <div style={headStyle}>
                        <h1>No Data</h1>
                        <Form.Select  style={yearSelect} onChange={statusChange}>
                            {[0, 1, 2, 3, 4, 5].map((num, index) => {
                                var yearOption = new Date().getFullYear() - num;
                                if(yearOption == year){
                                    return (<option selected value={yearOption}>{yearOption}</option>)
                                }
                                else{
                                    return (<option value={yearOption}>{yearOption}</option>)
                                }
                            })}
                        </Form.Select >
                    </div>
                </div>
            </div>
        </div>
    }
    else{
       return <div className="right_container">
            <div className="dashboard">
                <div className='inner-content'>
                    <div style={headStyle}>
                        <h1>{name}</h1>
                        <Form.Select style={yearSelect} onChange={statusChange}>
                            {[0, 1, 2, 3, 4, 5].map((num, index) => {
                                var yearOption = new Date().getFullYear() - num;
                                if(yearOption == year){
                                    return (<option selected value={yearOption}>{yearOption}</option>)
                                }
                                else{
                                    return (<option value={yearOption}>{yearOption}</option>)
                                }
                            
                            })}
                        </Form.Select>
                    </div>


                    <div style={imageContainer}>
                        {data?.map((item1, index1) => {
                            return JSON.parse(item1)?.map((item, index) => {
                                return <div key={index} className='media-item'>
                                    <img style={img} src={item.imageUrl.replace("itmatic.io", "codebrigade.in")} alt={item.caption} />
                                </div>
                            })
                        })}
                    </div>
                </div>
            </div>
        </div>
    }

}

const mapStateToProps = (state) => {
    return {
        user: state.user,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        dispatchLogin: (user) => dispatch({ type: 'LOGIN', data: user })
    };
};

export default MediaCollection;